<template lang="pug">
fieldset(:disabled="loading")
  form(@submit.prevent="onSubmit")
    modal(active, title="Reanálise", @close="$router.back()")
      div(slot="modal-body")
        p Você está #[b solicitando a reanálise da OS-m], isso significa que você vai encaminhar a OS-m para um novo analista.
        p Este processo #[b não é reversível].
        form-group(:label="'ordem_servico_analise.analista' | tModel" :validation="$v.form.analista_id")
          fiscal-picker(v-model="$v.form.analista_id.$model")
        form-group(:label="'ordem_servico_analise.parecer' | tModel" :validation="$v.form.parecer")
          textarea.form-input(rows="2" placeholder="Informe aqui o seu parecer" v-model.trim="$v.form.parecer.$model" v-autofocus)
      div(slot="modal-footer")
        button.btn.btn-primary(:disabled="$v.form.$invalid" :class="{loading}")
          btn-content(icon="fa fa-refresh" label="Reanálise")
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import { minLength, required } from "vuelidate/lib/validators"

export default {
  vuex: {
    "analises/minhasAnalises": {
      getters: ["loading"],
      state: ["current"],
      actions: ["fetchUpdate"],
    },
  },
  data() {
    return {
      form: {
        parecer: "",
        situacao: "reanalise",
        analista_id: null,
      },
    }
  },
  methods: {
    async onSubmit() {
      try {
        const data = { id: this.current.id, ...this.form }
        await this.fetchUpdate(data)
        this.$toaster.success("Reanalise solicitada")
        this.$router.back()
      } catch (e) {
        toastErrors(e)
      }
    },
  },
  validations: {
    form: {
      parecer: { minLength: minLength(10), required },
      analista_id: { required },
      situacao: { required },
    },
  },
}
</script>
